<template>
  <v-layout>
    <app-loader
      title="Загрузка данных Маршрута"
      :loading="loading"
    />
    <v-layout
      v-show="!loading"
      column
    >
      <v-flex xs12>
        <v-layout
          v-if="!compactMode"
          row
          wrap
        >
          <v-flex
            xs12
            md8
          >
            <v-card
              class="mt-0 mb-1 mr-1 ml-0 pa-2 "
              :style="{
                height: '440px',
                'overflow-y': 'auto',
                'overflow-x': 'hidden'
              }"
            >
              <v-layout align-center>
                <v-tooltip bottom>
                  <v-btn
                    slot="activator"
                    small
                    icon
                    class="ma-0"
                    @click="$router.go(-1)"
                  >
                    <v-icon color="grey darken-1">
                      arrow_back
                    </v-icon>
                  </v-btn>
                  <span>Назад</span>
                </v-tooltip>
                <h2 class="px-2 mr-2 subheading font-weight-bold title-style">
                  {{ `Маршрут: №${route ? route.number : ""}` }}
                </h2>
                <h2 class="px-2 mr-2 subheading font-weight-bold title-style">
                  Префикс:
                </h2>
                <span
                  v-if="!showRoutePrefixEditor"
                  class="subheading font-weight-bold mr-2 clickable-row"
                  @click="showRoutePrefixEditor = true"
                >{{ route.routePrefix ? route.routePrefix : "___" }}</span>
                <span
                  v-else
                  style="width:65px"
                >
                  <v-text-field
                    v-model="route.routePrefix"
                    hide-details
                    outline
                    append-icon="save"
                    height="30"
                    class="route-prefix"
                    maxlength="6"
                    autofocus
                    @click:append="saveRoutePrefix"
                    @blur="showRoutePrefixEditor = false"
                  />
                </span>
                <MenuStateChange
                  :id="id"
                  resource="route"
                  :is-delete-route="true"
                  class="mx-2 px-2"
                />
                <states-history
                  class="mr-2"
                  :route-id="id"
                />
                <span class="subheading font-weight-bold mr-2 ml-1">{{
                  route && route.direction ? route.direction.title : ""
                }}</span>
              </v-layout>
              <v-layout
                row
                wrap
              >
                <v-flex
                  xs12
                  md6
                  class="mt-2 pr-2"
                >
                  <LogistSelect
                    :value="logist"
                    :disabled-edit-btn="!logist"
                    @input="changeLogist"
                  />
                  <CustomsManagerSelect
                    :value="customsManager"
                    :disabled-edit-btn="!customsManager"
                    @input="changeCustomsManager"
                  />
                  <RouteReference
                    :value="forwarder"
                    label="Экспедиция"
                    resource="forwarders"
                    store-resource="route"
                    component-name="Forwarder"
                    :disabled-edit-btn="!forwarder"
                    @input="changeForwarder"
                  />
                  <v-tabs
                    :show-arrows="true"
                    next-icon="keyboard_arrow_right"
                    prev-icon="keyboard_arrow_left"
                    @change="changeActiveTab"
                  >
                    <v-tab style="text-transform:none">
                      <h2 class="subheading font-weight-bold">
                        Заметки
                      </h2>
                    </v-tab>
                    <v-tab style="text-transform:none">
                      <h2 class="subheading font-weight-bold">
                        Фото
                        <span
                          v-if="images.length > 0"
                          class="blue--text text--darken-4"
                        >{{ images.length }}</span>
                      </h2>
                    </v-tab>
                    <v-tab style="text-transform:none">
                      <h2 class="subheading font-weight-bold">
                        Документы
                        <span
                          v-if="attachments.length > 0"
                          class="blue--text text--darken-4"
                        >{{ attachments.length }}</span>
                      </h2>
                    </v-tab>
                    <v-tab-item>
                      <Notes :id="id" />
                    </v-tab-item>
                    <v-tab-item>
                      <ImagesList
                        :id="id"
                        :is-left="true"
                        block-height="200"
                        resource="routes"
                        @change="getImages"
                      />
                    </v-tab-item>
                    <v-tab-item>
                      <Attachments
                        :value="attachments"
                        :resource="`customs-entry-registrations/${id}`"
                        @input="changeAttachments"
                      />
                    </v-tab-item>
                  </v-tabs>
                </v-flex>
                <v-flex
                  xs12
                  md6
                  class="mt-2 pl-2"
                >
                  <v-layout>
                    <v-flex xs11>
                      <app-reference
                        v-model="carrier"
                        class="mb-2"
                        label="Перевозчик"
                        resource="carriers"
                        component-name="Carrier"
                        :outline="true"
                        :height-field="40"
                        :disable-add="true"
                        @input="changeCarrier"
                      />
                    </v-flex>
                  </v-layout>
                  <v-layout>
                    <v-flex xs11>
                      <RouteReference
                        :value="vehicle"
                        label="Номер машины"
                        resource="vehicles"
                        component-name="Vehicle"
                        :disabled-edit-btn="!vehicle"
                        store-resource="route"
                        :carrier-id="carrier ? carrier.id : null"
                        @input="changeVehicle"
                        @openEditDialog="showVehicleEditor = true"
                      />
                    </v-flex>
                    <v-dialog
                      :value="showVehicleEditor"
                      persistent
                      lazy
                      width="1000"
                    >
                      <vehicle
                        :id="vehicle ? vehicle.id.toString() : '0'"
                        :is-event-cancel="true"
                        :is-edit-in-modal="true"
                        @cancel="showVehicleEditor = false"
                        @save="saveChangedVehicle"
                      />
                    </v-dialog>
                  </v-layout>
                  <DriverSelect
                    resource="route"
                    :item="route"
                    store-resource="route"
                    class="pt-0 pb-0 info-list"
                    :carrier-id="carrier ? carrier.id : null"
                    @change="changeDriver"
                  />
                  <UnloadingPlaceSelect @change="getData" />
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
          <v-flex
            xs12
            md4
          >
            <v-card
              style="height: 440px"
              class="mt-0 mb-1 mr-0 ml-1 pa-3"
            >
              <v-data-table
                hide-actions
                :loading="loading"
                :headers="datesTableHeaders"
                :items="dateTableItems"
              >
                <template
                  slot="items"
                  slot-scope="props"
                >
                  <tr class="px-1">
                    <td style="width:50%">
                      {{ props.item.title }}
                    </td>
                    <td
                      v-if="!props.item.disablePlan"
                      class="date-picker"
                      style="width:25%"
                    >
                      <app-date-picker
                        v-if="props.item.source === 'route'"
                        v-model="route[props.item.plan]"
                        :without-initial-data="true"
                        :padding="0"
                        :outline="false"
                        :height-field="32"
                        :hide-data-type-icon="true"
                        @input="
                          saveRouteDates(
                            props.item.dateResource,
                            route[props.item.plan]
                          )
                        "
                      />
                      <app-date-picker
                        v-else
                        v-model="routeDates[props.item.plan]"
                        :without-initial-data="true"
                        :padding="0"
                        :outline="false"
                        :height-field="32"
                        :hide-data-type-icon="true"
                        @input="
                          saveRouteDates(
                            props.item.dateResource,
                            routeDates[props.item.plan]
                          )
                        "
                      />
                    </td>
                    <td
                      v-else
                      class="date-picker"
                      style="width:25%"
                    >
                      <span>
                        {{
                          props.item.source === "route"
                            ? route[props.item.plan]
                            : routeDates[props.item.plan] | date
                        }}
                      </span>
                    </td>
                    <td
                      class="date-picker"
                      style="width:25%"
                    >
                      {{
                        props.item.source === "route"
                          ? route[props.item.fact]
                          : routeDates[props.item.fact] | date
                      }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
              <v-data-table
                hide-actions
                :loading="loading"
                :headers="transportIndicatorsHeaders"
                :items="transportIndicatorsItems"
                class="mt-5"
              >
                <template v-slot:items="props">
                  <tr class="px-1">
                    <td style="width:40%">
                      <span
                        :class="{
                          'blue--text text--darken-4': props.item.blueText
                        }"
                      >{{ props.item.title }}</span>
                    </td>
                    <td
                      style="width:20%;"
                      class="text-xs-center"
                    >
                      {{ vehicle ? vehicle[props.item.car] : "" }}
                    </td>
                    <td
                      style="width:20%;"
                      class="text-xs-center"
                    >
                      {{ transportInfo[props.item.plan] }}
                    </td>
                    <td
                      style="width:20%;"
                      class="text-xs-center"
                    >
                      {{ transportInfo[props.item.inCar] }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
      <!--ITEMS-->
      <v-flex xs12>
        <v-card
          class="mt-1 mb-0 mx-0 pa-2"
          :style="{ height: blockHeight + 'px' }"
        >
          <v-layout>
            <h2 class="ma-0 subheading font-weight-bold">
              Поставки
            </h2>
            <ShippingPicker
              class="mb-1"
              :except="routeItems ? routeItems.map(i => i.shippingId) : []"
              :disabled="!canEditRouteItem"
              @pickup="addItems"
            />
            <v-spacer />
            <v-btn
              small
              icon
              :disabled="loading"
              class="mr-0"
              @click="changeCompactMode"
            >
              <v-icon>
                {{ compactMode ? "fullscreen_exit" : "fullscreen" }}
              </v-icon>
            </v-btn>
            <DataColumnsSettings
              :columns="columns"
              resource="route"
              :settings-button-style="{
                flat: true,
                colorButton: '',
                colorIcon: 'grey'
              }"
            />
          </v-layout>

          <v-tabs slider-color="primary">
            <v-tab>Поставки</v-tab>
            <v-tab>Способ упаковки</v-tab>
            <v-tab>Грузы поставок</v-tab>
            <v-tab-item :style="{ height: blockHeight - 60 + 'px' }">
              <v-data-table
                v-if="route"
                :loading="loadingItems"
                :items="routeItems"
                :headers="visibleColumns"
                hide-actions
                class="mb-1 v-data-table--fixed-header"
                style="overflow: auto"
              >
                <template
                  slot="headers"
                  slot-scope="props"
                >
                  <tr class="text-xs-left px-3">
                    <th
                      v-for="(header, index) in props.headers"
                      :key="index"
                      :style="{
                        minWidth: header.width ? `${header.width}px` : 'auto',
                        whiteSpace: header.width ? 'normal' : 'nowrap'
                      }"
                    >
                      {{ header.title }}
                    </th>
                  </tr>
                </template>
                <template
                  slot="items"
                  slot-scope="props"
                >
                  <tr
                    :class="
                      getTableRowColor(
                        props.item.readyDate,
                        props.item.deliveryToUnloadingPlacePlan
                      )
                    "
                  >
                    <td
                      v-for="column in visibleColumns"
                      :key="column.name"
                    >
                      <span v-if="column.type === 'object'">
                        {{
                          props.item[column.name]
                            ? props.item[column.name].title
                            : ""
                        }}
                      </span>
                      <a
                        v-if="column.type === 'loadingAddress'"
                        :style="{
                          cursor: props.item.senderFactory
                            ? 'pointer'
                            : 'default',
                          fontWeight: props.item.senderFactory
                            ? 'bold'
                            : 'normal',
                          'text-decoration': 'underline'
                        }"
                        @click="
                          props.item.senderFactory
                            ? showLoadingAddressEditor(props.item)
                            : null
                        "
                      >{{
                        props.item[column.name]
                          ? props.item[column.name].title
                          : ""
                      }}</a>
                      <span v-else-if="column.type === 'combo'">
                        {{
                          props.item[column.name]
                            ? props.item[column.name].title
                            : props.item[column.name2]
                              ? props.item[column.name2].title
                              : ""
                        }}
                      </span>
                      <span v-else-if="column.type === 'combo-deep'">{{
                        getLoadingPlace(props.item)
                      }}</span>
                      <span v-else-if="column.type === 'date'">{{
                        props.item[column.name] | date
                      }}</span>
                      <span v-else-if="column.type === 'postcode'">{{
                        props.item[column.name]
                      }}</span>
                      <span v-else-if="column.type === 'unloadingPlace'">
                        <UnloadingPlaceNumberSelect
                          :item="props.item"
                          @unloadingPlaceChange="
                            unloadingPlaceConfirmDialogActivate
                          "
                        />
                      </span>
                      <span v-else-if="column.type === 'label'">
                        <MenuLabelChange
                          v-if="column.name === 'inCar'"
                          :value="props.item[column.name]"
                          :item="props.item"
                          column="inCar"
                          tooltip="Завершите предыдущие звенья Заезд по Поставке"
                          :disabled="props.item.hasUndonePreviousPhase"
                          @change="inCarConfirmDialogActivate"
                        />
                        <MenuLabelChange
                          v-if="column.name === 'unloaded'"
                          :value="props.item[column.name]"
                          :item="props.item"
                          column="unloaded"
                          :disabled="disableUnloaded(props.item)"
                          @change="changeUnloaded"
                        />
                      </span>
                      <span
                        v-else-if="
                          column.type === 'delivery-to-unloading-place-plan'
                        "
                        class="editable-field"
                      >
                        <RouteItemDatePicker
                          :value="props.item[column.name]"
                          :item="props.item"
                          :column="column.name"
                          store="route"
                          @input="deliveryToUnloadingPlacePlanChanged"
                        />
                      </span>
                      <span
                        v-else-if="
                          column.type === 'delivery-to-unloading-place-fact'
                        "
                        class="editable-field"
                      >
                        <RouteItemDatePicker
                          :value="props.item[column.name]"
                          :item="props.item"
                          :column="column.name"
                          :min="
                            getMinDeliveryToUnloadingDate(
                              props.item,
                              column.name
                            )
                          "
                          :can-edit="canEditRouteItem"
                          store="route"
                          @input="deliveryToUnloadingPlaceFactChange"
                        />
                      </span>
                      <span
                        v-else-if="column.type === 'ready-date'"
                        class="editable-field"
                      >
                        <RouteItemDatePicker
                          :value="props.item[column.name]"
                          :item="props.item"
                          :column="column.name"
                          store="route"
                          @input="readyForShippmentFactChanged"
                        />
                      </span>
                      <span
                        v-else-if="column.type === 'factory-closing-date'"
                        class="editable-field"
                      >
                        <RouteItemDatePicker
                          v-if="сanEditFactoryClosingDate(props.item)"
                          :value="props.item[column.name]"
                          :item="props.item"
                          :column="column.name"
                          store="route"
                          @input="factoryClosingDateChanged"
                        />
                        <span v-else>
                          {{ props.item[column.name] | date }}
                        </span>
                      </span>
                      <span v-else-if="column.type === 'number'">
                        <LinkCell
                          :id="props.item.shippingId"
                          :text="props.item[column.name]"
                          resource="shippings"
                        />
                      </span>
                      <span v-else-if="column.type === 'menu'">
                        <v-btn
                          v-if="!menuRowActive"
                          icon
                          class="ma-0"
                          @mouseover="menuRowActive = true"
                        >
                          <v-icon color="grey">
                            more_vert
                          </v-icon>
                        </v-btn>
                        <MenuRowActions
                          v-else
                          :list="filteredRowActions"
                          :value="props.item"
                          :index="routeItems.indexOf(props.item)"
                          :last-index="routeItems.length - 1"
                          @removeItem="removeItem"
                          @editPhase="openPhaseDialog"
                        />
                      </span>
                      <span v-else-if="column.type === 'unloaded-date'">
                        {{
                          props.item.unloaded
                            ? $options.filters.date(props.item.unloadingDate)
                            : ""
                        }}
                      </span>
                      <span v-else-if="column.type === 'decimal-editor'">
                        <DialogDecimalEditor
                          :value="props.item[column.name]"
                          :route-item="props.item"
                          :route-id="id"
                          :column="column"
                          :headers="headers"
                          :can-edit="canEditRouteItem"
                          @changeColumnEditor="
                            val => {
                              column.editor = val;
                            }
                          "
                        />
                      </span>
                      <span v-else-if="column.type === 'numberOfItem'">
                        {{ routeItems.indexOf(props.item) + 1 }}
                      </span>
                      <div v-else-if="column.type === 'photo'">
                        <span :key="props.item.id">
                          <MenuImagesList
                            :shipping-id="props.item.shippingId"
                            resource="shippings"
                            :has-images-in-item="props.item.hasImages"
                          />
                        </span>
                      </div>
                      <div v-else-if="column.type === 'attachments'">
                        <span :key="props.item.id">
                          <MenuAttachments
                            :data="props.item.attachments"
                            :data-for-export="props.item.attachmentsForExport"
                            :user="currentUser"
                            :shipping-id="props.item.shippingId"
                            :shipping-state="props.item.shippingState"
                            @update="getRouteItems"
                          />
                        </span>
                      </div>
                      <span v-else-if="column.type === 'icon'">
                        <template>
                          <v-layout>
                            <v-icon
                              small
                              :disabled="routeItems.indexOf(props.item) === 0"
                              @click="moveUp(props.item)"
                            >
                              arrow_upward
                            </v-icon>
                            <v-icon
                              small
                              :disabled="
                                routeItems.indexOf(props.item) ===
                                  routeItems.length - 1
                              "
                              @click="moveDown(props.item)"
                            >
                              arrow_downward
                            </v-icon>
                          </v-layout>
                        </template>
                      </span>
                      <span
                        v-else-if="column.type === 'notification'"
                        @click="openPhaseDialog(props.item)"
                      >
                        <TableCell
                          v-if="props.item[column.name]"
                          :icon="column.icon"
                          :tooltip="column.tooltip"
                          color="green"
                        />
                      </span>
                      <span v-else-if="column.type === 'text-editor'">
                        <DialogTextEditor
                          :value="props.item[column.name]"
                          :route-item="props.item"
                          :column="column.name"
                          @change="loadingLogistChange"
                        />
                      </span>
                      <span v-else-if="column.type === 'check-box'">
                        <v-checkbox
                          v-model="props.item[column.name]"
                          :disabled="
                            getDisableAllowingEditingRouteItem(props.item)
                          "
                          hide-details
                          @change="allowEditingRouteItem(props.item)"
                        />
                      </span>
                      <span
                        v-else
                        :class="{
                          'editable-field': props.item.totalDataFromGoodDetails
                        }"
                      >{{ props.item[column.name] }}</span>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-tab-item>
            <v-tab-item>
              <PackagesGroupedTable
                :route-packages="packages"
                :block-height="blockHeight - 60"
                :route-id="id"
                @change="getPackages"
              />
            </v-tab-item>
            <v-tab-item>
              <ShippingsPackagesTable
                :shippings-packages="shippingsPackages"
                :route-id="id"
                @change="updatePackages"
              />
            </v-tab-item>
          </v-tabs>

          <v-dialog
            v-if="phasesEditorDialog"
            v-model="phasesEditorDialog"
            width="1200"
            persistent
          >
            <v-card>
              <PickUpEditor
                v-if="isPickup(activePhase)"
                v-model="editingPhase"
                :disabled="!isCanEditPhase"
                :user="currentUser"
                :from-route="true"
                :is-disabled-add-comment="!canEditRouteItem"
                @cancel="closePhaseDialog"
                @readComments="markAsReadCommentsInPhase"
                @add-comment="updateComment"
                @update="getRouteItems"
              />
              <CombinationEditor
                v-if="isCombination(activePhase)"
                v-model="editingPhase"
                :disabled="!isCanEditPhase"
                :user="currentUser"
                :from-route="true"
                :is-disabled-add-comment="!canEditRouteItem"
                @cancel="closePhaseDialog"
                @readComments="markAsReadCommentsInPhase"
                @add-comment="updateComment"
                @update="getRouteItems"
              />
            </v-card>
          </v-dialog>

          <app-action-confirm
            :value="inCarConfirmActionDialog"
            :text="inCarConfirmActionDialogText"
            @cancel="closeInCarConfirmDialog"
            @confirm="inCarChange"
          />
          <app-action-confirm
            :value="unloadingPlaceConfirmActionDialog"
            :text="
              `Было изменено значение 'Места выгрузки' в Поставке №${joinedShippingNumbers}. Применить изменения?`
            "
            @cancel="closeUnloadingPlaceConfirmDialog"
            @confirm="unloadingPlaceChange"
          />
          <loading-address-edit-form
            :value="showLoadingAddressEditForm"
            @confirm="changeLoadingAddress"
            @cancel="showLoadingAddressEditForm = false"
          />
          <app-action-confirm
            :value="routeInfoConfirmActionDialog"
            :text="
              `Подтвердить удаление значения в поле ${
                editableRouteInfoItem ? editableRouteInfoItem.title : ''
              }?`
            "
            @cancel="closeRouteInfoConfirmDialog"
            @confirm="routeInfoConfirmAction"
          />
        </v-card>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import ConfirmMixin from "../../mixins/confirm-cancel-changes.js";
import ShippingPicker from "./components/ShippingPicker.vue";
import arrayMove from "array-move";
import Vehicle from "../vehicles/Vehicle.vue";
import LoadingAddressEditForm from "./components/LoadingAddressEditForm.vue";
import DataColumnsSettings from "../../components/data-list/ColumnsSettings.vue";
import LogistSelect from "./components/LogistSelect.vue";
import CustomsManagerSelect from "./components/CustomsManagerSelect.vue";
import DriverSelect from "./components/DriverSelect.vue";
import UnloadingPlaceSelect from "./components/UnloadingPlaceSelect.vue";
import MenuLabelChange from "./components/MenuLabelChange.vue";
import UnloadingPlaceNumberSelect from "./components/UnloadingPlaceNumberSelect.vue";
import LinkCell from "../../components/LinkCell.vue";
import PickUpEditor from "../shippings/components/phases/PickUpEditor.vue";
import CombinationEditor from "../shippings/components/phases/CombinationEditor.vue";
import MenuStateChange from "./components/MenuStateChange.vue";
import RouteItemDatePicker from "./components/RouteItemDatePicker.vue";
import RouteReference from "./components/RouteReference.vue";
import DialogDecimalEditor from "./components/DialogDecimalEditor.vue";
import StatesHistory from "./components/StatesHistory.vue";
import Notes from "./components/Notes.vue";
import ImagesList from "../../components/images/ImagesList.vue";
import MenuImagesList from "./components/MenuImagesList.vue";
import PackagesGroupedTable from "./components/packages/PackagesGroupedTable.vue";
import TableCell from "../../components/TableCell.vue";
import { ePhaseTypes as phaseTypes } from "../shippings/components/phases/shipping-phase-types.js";
import * as routesApi from "../../backend/routesApi.js";
import { changeReadyForShipmentFact } from "../../backend/shippingsApi.js";
import { getPhaseId } from "../../backend/phasesApi.js";
import { userRoles } from "../../enums/user-roles.js";
import auth from "../../auth.js";
import { phaseStates } from "../shippings/components/phases/shipping-phase-states.js";
import MenuAttachments from "./components/MenuAttachments.vue";
import Attachments from "../../components/attachments/Attachments.vue";
import DialogTextEditor from "./components/DialogTextEditor.vue";
import ShippingsPackagesTable from "./components/packages/ShippingsPackagesTable.vue";

export default {
  components: {
    Attachments,
    MenuAttachments,
    ShippingPicker,
    Vehicle,
    DataColumnsSettings,
    LoadingAddressEditForm,
    LogistSelect,
    CustomsManagerSelect,
    DriverSelect,
    UnloadingPlaceSelect,
    MenuLabelChange,
    UnloadingPlaceNumberSelect,
    LinkCell,
    PickUpEditor,
    CombinationEditor,
    MenuStateChange,
    RouteItemDatePicker,
    RouteReference,
    DialogDecimalEditor,
    StatesHistory,
    Notes,
    ImagesList,
    MenuImagesList,
    PackagesGroupedTable,
    TableCell,
    DialogTextEditor,
    ShippingsPackagesTable,
  },
  mixins: [ConfirmMixin],
  props: ["id"],
  data() {
    return {
      inCarConfirmActionDialog: false,
      inCarConfirmActionDialogText: "",
      unloadingPlaceConfirmActionDialog: false,
      showVehicleEditor: false,
      showLoadingAddressEditForm: false,
      phasesEditorDialog: false,
      activePhase: null,
      editingPhase: null,
      labelDialog: false,
      headers: [
        {
          title: "",
          name: "hasUnreadNotes",
          type: "notification",
          icon: "mail",
          tooltip: "Новый комментарий",
          sortable: false,
          order: 0,
          visible: true,
        },
        {
          title: "",
          name: "moving",
          sortable: false,
          type: "icon",
          order: 0,
          visible: true,
        },
        {
          title: "№",
          name: "numberOfItem",
          sortable: false,
          type: "numberOfItem",
          order: 0,
          visible: true,
        },
        {
          title: "Место погрузки (продавец, склад, машина)",
          name: "loadingPlace",
          sortable: false,
          width: 180,
          type: "combo-deep",
        },
        {
          title: "Индекс",
          name: "postcode",
          sortable: false,
          type: "postcode",
        },
        {
          title: "Адрес погрузки",
          name: "loadingAddress",
          sortable: false,
          type: "loadingAddress",
        },
        {
          title: "№ поставки",
          name: "number",
          sortable: false,
          type: "number",
        },
        {
          title: "Место выгрузки",
          name: "unloadingPlace",
          sortable: false,
          type: "unloadingPlace",
        },
        {
          title: "Метка в машине",
          name: "inCar",
          sortable: false,
          type: "label",
        },
        {
          title: "Выгружено",
          name: "unloaded",
          sortable: false,
          type: "label",
        },
        {
          title: "Дата выгрузки",
          name: "unloadedDate",
          sortable: false,
          type: "unloaded-date",
        },
        {
          title: "Описание товара",
          name: "productDescription",
          sortable: false,
        },
        {
          title: "Референс погрузки",
          name: "loadingNumber",
          sortable: false,
        },
        {
          title: "Комментарий к погрузке",
          name: "cargoComment",
          sortable: false,
        },
        {
          title: "Референс логиста",
          name: "loadingLogist",
          sortable: false,
          type: "text-editor",
        },
        {
          title: "Продавец",
          name: "shippingSenderFactory",
          name2: "shippingSenderWarehouse",
          sortable: false,
          type: "combo",
        },
        {
          title: "Тип Звена",
          name: "phaseType",
          sortable: false,
          width: 80,
          type: "combo",
        },
        {
          title: "Объем",
          name: "volume",
          sortable: false,
          type: "decimal-editor",
          scale: 3,
          editor: false,
        },
        {
          title: "Вес брутто",
          name: "weight",
          sortable: false,
          type: "decimal-editor",
          scale: 3,
          editor: false,
        },
        {
          title: "Кол-во мест",
          name: "cargoPlaces",
          sortable: false,
          type: "decimal-editor",
          editor: false,
        },
        {
          title: "Дата готовности",
          name: "readyDate",
          sortable: false,
          width: 80,
          type: "ready-date",
        },
        {
          title: "Дата закрытия фабрики",
          name: "factoryClosingDate",
          sortable: false,
          width: 80,
          type: "factory-closing-date",
        },
        {
          title: "Дата забора план",
          name: "deliveryToUnloadingPlacePlan",
          sortable: false,
          width: 80,
          type: "delivery-to-unloading-place-plan",
          editor: false,
        },
        {
          title: "Дата забора факт",
          name: "deliveryToUnloadingPlaceFact",
          sortable: false,
          width: 80,
          type: "delivery-to-unloading-place-fact",
          editor: false,
        },
        {
          title: "Клиент по документам",
          name: "clientAlias",
          name2: "Aliases",
          sortable: false,
          width: 100,
        },
        {
          title: "Фото",
          name: "photo",
          type: "photo",
          sortable: false,
          width: 50,
        },
        {
          title: "Документы",
          name: "attachments",
          type: "attachments",
          sortable: false,
          width: 50,
        },
        {
          title: "Разрешить редактировать",
          name: "allowEditing",
          type: "check-box",
          sortable: false,
          width: 50,
        },
        {
          title: "",
          name: "menu",
          sortable: false,
          type: "menu",
          visible: true,
          order: 27,
        },
      ],
      showRoutePrefixEditor: false,
      shippingNumbers: [],
      loading: false,
      routeInfoConfirmActionDialog: false,
      loadingItems: false,
      menuRowActive: false,
      datesTableHeaders: [
        {
          text: "Даты прибытия",
          sortable: false,
        },
        {
          text: "План",
          sortable: false,
        },
        {
          text: "Факт",
          sortable: false,
        },
      ],
      dateTableItems: [
        {
          title: "Начало маршрута",
          plan: "startOfRoutePlan",
          fact: "startOfRouteFact",
          disablePlan: true,
          source: "routeItems",
          dateResource: "startOfRoute",
        },
        {
          title: "Затаможка",
          plan: "customsRegistrationDatePlan",
          fact: "customsRegistrationDateFact",
          source: "route",
          dateResource: "customsRegistrationDate",
        },
        {
          title: "Доставка к последнему месту выгрузки",
          plan: "arriveToWarehouseDatePlan",
          fact: "arriveToWarehouseDateFact",
          source: "route",
          dateResource: "arriveToWarehouseDate",
        },
      ],
      transportIndicatorsHeaders: [
        {
          text: "",
          sortable: false,
        },
        {
          text: "Машина",
          sortable: false,
          align: "center",
        },
        {
          text: "План",
          sortable: false,
          align: "center",
        },
        {
          text: "Отгружено",
          sortable: false,
          align: "center",
        },
      ],
      transportIndicatorsItems: [
        {
          title: "Общий объем",
          blueText: true,
          car: "volume",
          plan: "volume",
          inCar: "overallVolumeInCar",
        },
        {
          title: "Грузоподъемность",
          blueText: true,
          car: "carryingCapacity",
          plan: "weightPlan",
          inCar: "weightInCar",
        },
        {
          title: "Количество мест",
          car: "",
          plan: "cargoPlaces",
          inCar: "cargoPlacesInCar",
        },
      ],
      activeTab: 0,
      images: [],
      packages: [],
      isCanEditPhase: false,
      shippingsPackages: [],
    };
  },
  computed: {
    rowActions() {
      return [
        {
          title: "Изменить звено",
          name: "editPhase",
          action: this.openPhaseDialog,
          type: "icon",
          icon: "edit",
          disabled: false,
        },
        {
          title: "Удалить",
          name: "removeItem",
          action: this.removeItem,
          type: "icon",
          icon: "delete",
          disabled: false,
        },
      ];
    },
    filteredRowActions() {
      return this.rowActions.map(r => {
        return {
          title: r.title,
          name: r.name,
          type: r.type,
          icon: r.icon,
          disabled: r.disabled,
        };
      });
    },
    blockHeight() {
      return this.compactMode
        ? window.innerHeight - 46
        : window.innerHeight - 494;
    },
    route() {
      return this.$store.getters["route/getRoute"];
    },
    logist: {
      get() {
        return this.$store.getters["route/getLogist"];
      },
      set(value) {
        this.$store.commit("route/setLogist", value);
      },
    },
    customsManager: {
      get() {
        return this.$store.getters["route/getCustomsManager"];
      },
      set(value) {
        this.$store.commit("route/setCustomsManager", value);
      },
    },
    forwarder: {
      get() {
        return this.$store.getters["route/getForwarder"];
      },
      set(value) {
        this.$store.commit("route/setForwarder", value);
      },
    },
    vehicle: {
      get() {
        return this.$store.getters["route/getVehicle"];
      },
      set(value) {
        this.$store.commit("route/setVehicle", value);
      },
    },
    storeColumns() {
      return this.$store.getters["route/columns"];
    },
    visibleColumns() {
      const columns = JSON.parse(JSON.stringify(this.headers));
      columns.forEach(c => {
        const column = this.storeColumns.find(sc => sc.name === c.name);
        if (column) {
          c.visible = column.visible;
          c.order = column.order;
        }
      });
      columns.sort((a, b) => {
        let aOrder = 0;
        if (Object.prototype.hasOwnProperty.call(a, "order")) {
          aOrder = a.order;
        } else {
          aOrder = this.headers.indexOf(a);
        }
        let bOrder = 0;
        if (Object.prototype.hasOwnProperty.call(b, "order")) {
          bOrder = b.order;
        } else {
          bOrder = this.headers.indexOf(b);
        }
        if (aOrder < bOrder) {
          return -1;
        }
        if (aOrder > bOrder) {
          return 1;
        }
        return 0;
      });
      return columns.filter(c => c.visible);
    },
    defaultWarehouse() {
      return this.$store.getters["route/defaultWarehouse"];
    },
    unloadingPlaces() {
      return this.$store.getters["route/unloadingPlaces"];
    },
    joinedShippingNumbers() {
      return Array.from(new Set(this.shippingNumbers)).join("; ");
    },
    editableRouteInfoItem() {
      return this.$store.getters["route/editableRouteInfoItem"];
    },
    transportInfo() {
      return this.$store.getters["route/transportInfo"];
    },
    routeItems() {
      return this.$store.getters["route/routeItems"];
    },
    routeDates() {
      return this.$store.getters["route/routeDates"];
    },
    editableRouteItem() {
      return this.$store.getters["route/editableRouteItem"];
    },
    compactMode: {
      get() {
        return this.$store.getters["route/compactMode"];
      },
      set(value) {
        this.$store.commit("route/setCompactMode", value);
      },
    },
    currentUser() {
      return auth.getUser();
    },
    canEditRouteItem() {
      if (
        this.currentUser.roles.find(
          r => r.id === userRoles.Logist || r.id === userRoles.Admin,
        )
      ) {
        return true;
      }
      return false;
    },
    isUserIsLogist() {
      return this.currentUser.employeeId === this.logist?.id;
    },
    carrier: {
      get() {
        return this.$store.getters["route/getCarrier"];
      },
      set(value) {
        this.$store.commit("route/setCarrier", value);
      },
    },
    columns() {
      const columns = JSON.parse(JSON.stringify(this.headers));
      columns.forEach(c => {
        c.visible = true;
        c.order = 0;
      });
      return columns.filter(
        c =>
          c.title &&
          c.type !== "notification" &&
          c.type !== "numberOfItem" &&
          c.type !== "icon" &&
          c.type !== "menu",
      );
    },
    isAdmin() {
      return auth.isAdmin();
    },
    attachments() {
      return this.$store.getters["route/getAttachments"];
    },
  },
  created() {
    this.$store.commit("route/setRouteItems", []);
    this.getData();
  },
  methods: {
    async getData() {
      this.loading = true;
      await this.$store.dispatch("route/getDefaultWarehouse");
      await this.$store.dispatch("route/getRouteInfo", this.id);
      this.loading = false;
      this.loadingItems = true;
      await this.$store.dispatch("route/getRouteItems", this.id);
      await this.getPackages();
      await this.getShippingsPackages();
      this.loadingItems = false;
    },

    //routeInfo
    async saveRoutePrefix() {
      await this.$store.dispatch("route/saveRoutePrefix");
      this.showRoutePrefixEditor = false;
      this.showInfo("Префикс сохранен");
    },
    changeLogist(element) {
      if (element) {
        this.changeRouteInfoItem("logist", element);
      } else {
        this.$store.commit("route/setEditableRouteInfoItem", {
          title: "Логист",
          name: "logist",
          value: element,
        });
        this.routeInfoConfirmActionDialog = true;
      }
    },
    changeCustomsManager(element) {
      if (element) {
        this.changeRouteInfoItem("customs-manager", element);
      } else {
        this.$store.commit("route/setEditableRouteInfoItem", {
          title: "Менеджер по затаможке",
          name: "customs-manager",
          value: element,
        });
        this.routeInfoConfirmActionDialog = true;
      }
    },
    changeForwarder(element) {
      if (element) {
        this.changeRouteInfoItem("forwarder", element);
      } else {
        this.$store.commit("route/setEditableRouteInfoItem", {
          title: "Экспедитор",
          name: "forwarder",
          value: element,
        });
        this.routeInfoConfirmActionDialog = true;
      }
    },
    changeVehicle(element) {
      if (element) {
        this.changeRouteInfoItem("vehicle", element);
      } else {
        this.$store.commit("route/setEditableRouteInfoItem", {
          title: "Номер машины",
          name: "vehicle",
          value: element,
        });
        this.routeInfoConfirmActionDialog = true;
      }
    },
    async saveChangedVehicle() {
      this.showVehicleEditor = false;
      this.loading = true;
      await this.$store.dispatch("route/getRouteInfo", this.id);
      this.loading = false;
    },
    changeDriver(element) {
      if (element) {
        this.changeRouteInfoItem("driver", element);
      } else {
        this.$store.commit("route/setEditableRouteInfoItem", {
          title: "Водитель",
          name: "driver",
          value: element,
        });
        this.routeInfoConfirmActionDialog = true;
      }
    },
    changeCarrier(element) {
      if (element) {
        this.changeRouteInfoItem("carrier", element);
      } else {
        this.$store.commit("route/setEditableRouteInfoItem", {
          title: "Перевозчик",
          name: "carrier",
          value: element,
        });
        this.routeInfoConfirmActionDialog = true;
      }
    },
    async changeRouteInfoItem(name, element) {
      await this.$store.dispatch("route/changeRouteInfoItem", {
        id: this.id,
        name,
        element,
      });
      this.showInfo("Изменения сохранены");
    },
    routeInfoConfirmAction() {
      this.changeRouteInfoItem(
        this.editableRouteInfoItem.name,
        this.editableRouteInfoItem.value,
      );
      this.routeInfoConfirmActionDialog = false;
    },
    closeRouteInfoConfirmDialog() {
      this.routeInfoConfirmActionDialog = false;
    },

    //routeDates
    async saveRouteDates(resource, date) {
      if (resource === "customsRegistrationDate") {
        await this.$store.dispatch("route/saveCustomsRegistrationDate", {
          id: this.id,
          date,
        });
        this.showInfo("Дата(план) 'Затаможка' изменена");
      } else if (resource === "arriveToWarehouseDate") {
        await this.$store.dispatch("route/saveArriveToWarehouseDate", {
          id: this.id,
          date,
        });
        this.showInfo(
          "Дата(план) 'Доставка к последнему месту выгрузки' изменена",
        );
      }
    },

    //loadingAddressChange
    showLoadingAddressEditor(shipping) {
      this.$store.commit("route/setEditableRouteItem", shipping);
      this.showLoadingAddressEditForm = true;
    },
    async changeLoadingAddress() {
      this.showLoadingAddressEditForm = false;
      this.$store.commit("route/setEditableRouteItem", null);
      this.loadingItems = true;
      await this.$store.dispatch("route/getRouteItems", this.id);
      this.loadingItems = false;
    },

    //uloadingPlaceChange
    getLoadingPlace(value) {
      if (value.id === 0) {
        return value.shippingSenderWarehouse
          ? value.shippingSenderWarehouse.title
          : value.shippingSenderFactory
            ? value.shippingSenderFactory.title
            : value.shippingSenderAddress
              ? value.shippingSenderAddress.title
              : "";
      } else {
        return value.senderWarehouse
          ? value.senderWarehouse.title
          : value.senderFactory
            ? value.senderFactory.title
            : value.senderAddress
              ? value.senderAddress.title
              : "";
      }
    },
    unloadingPlaceConfirmDialogActivate() {
      this.shippingNumbers.push(this.editableRouteItem.number);
      this.unloadingPlaceConfirmActionDialog = true;
    },
    async unloadingPlaceChange() {
      this.unloadingPlaceConfirmActionDialog = false;
      this.shippingNumbers = [];
      try {
        this.loadingItems = true;
        await routesApi.updateUnloadingPlaceRouteItem(
          this.id,
          this.editableRouteItem.id,
          this.editableRouteItem.unloadingPlaceId,
        );
        this.loadingItems = false;
        this.$store.dispatch("route/changeRouteItem", "unloadingPlaceId");
        this.showInfo("Место выгрузки изменено");
      } catch (error) {
        this.loadingItems = false;
        if (error.message) {
          this.showError(error.message);
        } else {
          throw error;
        }
      }
    },
    closeUnloadingPlaceConfirmDialog() {
      this.unloadingPlaceConfirmActionDialog = false;
      this.editableRouteItem = null;
    },

    //inCarChange
    inCarConfirmDialogActivate(inCar) {
      if (!inCar) {
        this.inCarConfirmActionDialogText =
          "Было изменено значение метки 'В Машине'. Применить изменения?";
        this.inCarConfirmActionDialog = true;
      } else {
        this.inCarChange(inCar);
      }
    },
    async inCarChange(value) {
      this.inCarConfirmActionDialog = false;
      try {
        this.loadingItems = true;
        await routesApi.updateInCar(this.id, this.editableRouteItem.id);
        this.$store.dispatch("route/changeRouteItem", "inCar");
        await this.deliveryToUnloadingPlaceFactChanged();
        await this.$store.dispatch("route/getRouteItems", this.id);
        this.loadingItems = false;
        this.showInfo("Метка в машине изменена");
        if (value) {
          setTimeout(() => {
            this.showInfo(
              "Внесите фактически погруженный Объем, Вес брутто, Количество мест, Дату забора факт в Звено",
            );
          }, 3000);
        }
      } catch (error) {
        this.loadingItems = false;
        if (error.message) {
          this.showError(error.message);
        } else {
          throw error;
        }
      }
    },
    closeInCarConfirmDialog() {
      this.inCarConfirmActionDialog = false;
    },

    //unloadedChange
    disableUnloaded(item) {
      if (!item.unloadingPlaceId) {
        return true;
      }
      const places = this.unloadingPlaces.slice();
      const currentPlace = places.find(i => {
        return i.id === item.unloadingPlaceId;
      });
      return (
        this.defaultWarehouse.unloadingAddress.id ===
          currentPlace?.unloadingAddress?.id || item.hasAwaitingPreviousPhase
      );
    },
    async changeUnloaded() {
      try {
        this.loadingItems = true;
        await routesApi.changeUnloaded(
          this.id,
          this.editableRouteItem.id,
          this.editableRouteItem.unloadingDate,
        );
        this.loadingItems = false;
        this.$store.dispatch("route/changeRouteItem", "unloaded");
        this.$store.dispatch("route/changeRouteItem", "unloadingDate");
        this.showInfo("Метка Выгружено и Дата выгрузки изменены");
      } catch (error) {
        this.loadingItems = false;
        if (error.message) {
          this.showError(error.message);
        } else {
          throw error;
        }
      }
    },

    //readyDateChange
    async readyForShippmentFactChanged() {
      try {
        this.loadingItems = true;
        await changeReadyForShipmentFact(
          this.editableRouteItem.shippingId,
          this.editableRouteItem.phaseId,
          this.editableRouteItem.readyDate,
        );
        this.$store.dispatch("route/getRouteItems", this.id);
        this.loadingItems = false;
        this.showInfo("Дата готовности сохранена");
      } catch (error) {
        this.loadingItems = false;
        if (error.message) {
          this.showError(error.message);
        } else {
          throw error;
        }
      }
    },

    //factoryClosingDateChanged
    async factoryClosingDateChanged() {
      try {
        this.loadingItems = true;
        await routesApi.changeFactoryClosingDate(
          this.id,
          this.editableRouteItem.id,
          this.editableRouteItem.factoryClosingDate,
        );
        this.$store.dispatch("route/getRouteItems", this.id);
        this.loadingItems = false;
        this.showInfo("Дата закрытия фабрики сохранена");
      } catch (error) {
        if (error.message) {
          this.loadingItems = false;
          this.showError(error.message);
        } else {
          this.loadingItems = false;
          throw error;
        }
      }
    },

    //planDateChange
    async deliveryToUnloadingPlacePlanChanged() {
      if (!this.canEditRouteItem) {
        return;
      }
      try {
        this.loadingItems = true;
        await routesApi.changeDeliveryToUnloadingPlacePlanDate(
          this.id,
          this.editableRouteItem.id,
          this.editableRouteItem.deliveryToUnloadingPlacePlan,
        );
        this.loadingItems = false;
        this.$store.dispatch("route/getRouteItems", this.id);
        this.showInfo("Дата забора план сохранена");
      } catch (error) {
        this.loadingItems = false;
        if (error.message) {
          this.showError(error.message);
        } else {
          throw error;
        }
      }
    },

    //factDateChange
    getMinDeliveryToUnloadingDate(item, fieldName) {
      const itemIndex = this.routeItems.indexOf(item);
      if (itemIndex > 0 && this.routeItems[itemIndex - 1][fieldName]) {
        return this.moment(this.routeItems[itemIndex - 1][fieldName]).format(
          "YYYY-MM-DD",
        );
      }
      if (itemIndex > 0 && !this.routeItems[itemIndex - 1][fieldName]) {
        for (let i = itemIndex - 1; i >= 0; i--) {
          if (this.routeItems[i][fieldName]) {
            return this.moment(this.routeItems[i][fieldName]).format(
              "YYYY-MM-DD",
            );
          }
        }
      }
      return null;
    },
    async deliveryToUnloadingPlaceFactChanged() {
      try {
        this.loadingItems = true;
        await routesApi.changeDeliveryToUnloadingPlaceFactDate(
          this.id,
          this.editableRouteItem.id,
          this.editableRouteItem.deliveryToUnloadingPlaceFact,
        );
        this.loadingItems = false;
        this.$store.dispatch("route/getRouteItems", this.id);
        this.showInfo("Дата забора факт сохранена");
      } catch (error) {
        this.loadingItems = false;
        if (error.message) {
          this.showError(error.message);
        } else {
          throw error;
        }
      }
    },
    deliveryToUnloadingPlaceFactChange() {
      if (!this.editableRouteItem.inCar) {
        const routeItem = { ...this.editableRouteItem };
        routeItem.inCar = true;
        this.$store.commit("route/setEditableRouteItem", routeItem);
        this.inCarChange();
        return;
      }
      this.deliveryToUnloadingPlaceFactChanged();
    },

    //rowActions
    async moveUp(item) {
      const from = this.routeItems.indexOf(item);
      const to = from === 0 ? 0 : from - 1;
      let items = this.routeItems;
      items = arrayMove(items, from, to);
      if (from !== 0) {
        this.loadingItems = true;
        await routesApi.changeItemPosition(this.id, item.id, to);
        this.loadingItems = false;
        this.$store.commit("route/setRouteItems", items);
        this.showInfo("Позиция звена изменена");
      }
      this.menuRowActive = false;
    },
    async moveDown(item) {
      const from = this.routeItems.indexOf(item);
      const to = from === this.routeItems.length - 1 ? from : from + 1;
      let items = this.routeItems;
      items = arrayMove(items, from, to);
      if (from !== this.routeItems.length - 1) {
        this.loadingItems = true;
        await routesApi.changeItemPosition(this.id, item.id, to);
        this.loadingItems = false;
        this.$store.commit("route/setRouteItems", items);
        this.showInfo("Позиция звена изменена");
      }
      this.menuRowActive = false;
    },
    async removeItem(item) {
      this.menuRowActive = false;
      const items = this.routeItems;
      items.splice(items.indexOf(item), 1);
      this.loadingItems = true;
      await routesApi.deleteItem(this.id, item.id);
      this.loadingItems = false;
      this.$store.commit("route/setRouteItems", items);
      await this.getPackages();
      this.showInfo("Звено удалено");
    },
    async openPhaseDialog(routeItem) {
      this.activePhase = {
        value: routeItem.phaseType.id,
        title: this.isPickup(routeItem.phaseType)
          ? "Заезд"
          : this.isCombination(routeItem.phaseType)
            ? "Свозка"
            : "Нестандарт",
      };
      this.menuRowActive = false;
      this.loadingItems = true;
      this.editingPhase = await getPhaseId(
        routeItem.shippingId,
        routeItem.phaseId,
      );
      this.$store.commit("route/setEditableRouteItem", routeItem);
      if (this.currentUser.employeeId === this.logist?.id) {
        this.editingPhase.comments.forEach(c => {
          if (c.author?.id === this.currentUser.id || this.isAdmin) {
            c.disabled = false;
            c.isReaded = true;
          } else {
            c.disabled = true;
          }
        });
      } else {
        this.editingPhase.comments.forEach(c => {
          if (c.author?.id === this.currentUser.id || this.isAdmin) {
            c.disabled = false;
          } else {
            c.disabled = true;
          }
          c.isReaded = true;
        });
      }
      this.loadingItems = false;
      this.$store.commit("shipping/setId", routeItem.shippingId);
      if (
        this.canEditRouteItem &&
        routeItem &&
        !routeItem.inCar &&
        this.editingPhase.state !== phaseStates.DONE
      ) {
        this.isCanEditPhase = true;
      } else {
        this.isCanEditPhase = false;
      }
      this.phasesEditorDialog = true;
    },
    closePhaseDialog() {
      this.editingPhase = null;
      this.phasesEditorDialog = false;
    },
    isPickup(phase) {
      return phase.value === phaseTypes.PICKUP;
    },
    isCombination(phase) {
      return phase.value === phaseTypes.COMBINATION;
    },
    isNonStandart(phase) {
      return phase.value === phaseTypes.NONSTANDART;
    },
    async allowEditingRouteItem(item) {
      this.loadingItems = true;
      await routesApi.allowEditingRouteItem(this.id, item.id);
      await this.$store.dispatch("route/getRouteItems", this.id);
      this.loadingItems = false;
    },
    getDisableAllowingEditingRouteItem(item) {
      if (item.inCar) {
        return true;
      } else {
        return (
          item.phaseType?.id === phaseTypes.PICKUP &&
          item.phaseState?.id === phaseStates.DONE &&
          item.arrivalAddress?.id ===
            this.defaultWarehouse?.unloadingAddress?.id &&
          this.canEditRouteItem
        );
      }
    },
    markAsReadCommentsInPhase() {
      const item = { ...this.editableRouteItem };
      item.hasUnreadNotes = false;
      this.$store.commit("route/setEditableRouteItem", item);
      this.$store.dispatch("route/changeRouteItem", "hasUnreadNotes");
    },
    updateComment(comments) {
      this.editingPhase.comments = comments;
    },
    async addItems(shippings) {
      const items = shippings.map(i => i.phaseId);
      this.loadingItems = true;
      await routesApi.addRouteItems(this.id, items);
      await this.$store.dispatch("route/getRouteItems", this.id);
      await this.getPackages();
      await this.getShippingsPackages();
      this.loadingItems = false;
    },
    openRowItemEditor(routeItem, column) {
      const item = { ...routeItem };
      item[column] = true;
      this.$store.commit("route/setEditableRouteItem", item);
      this.$store.dispatch("route/changeRouteItem", column);
    },
    changeCompactMode() {
      this.$store.commit("route/setCompactMode", !this.compactMode);
    },
    changeActiveTab(value) {
      return (this.activeTab = value);
    },
    getImages(images) {
      if (images) {
        this.images = images;
      }
    },
    сanEditFactoryClosingDate(item) {
      return (
        item.shippingIsFirstInRoutePhase &&
        (this.isUserIsLogist || this.isAdmin)
      );
    },
    async getPackages() {
      this.packages = await routesApi.getPackages(this.id);
    },
    async getRouteItems() {
      this.loadingItems = true;
      await this.$store.dispatch("route/getRouteItems", this.id);
      this.loadingItems = false;
    },
    getTableRowColor(dateFirst, dateSecond) {
      if (!dateFirst || !dateSecond) {
        return;
      }
      const timeFirst = new Date(dateFirst).getTime();
      const timeSecond = new Date(dateSecond).getTime();
      if (timeFirst > timeSecond) {
        return "red lighten-4";
      } else {
        return;
      }
    },
    changeAttachments(value) {
      this.$store.commit("shipping/setAttachments", value);
    },
    async loadingLogistChange() {
      try {
        this.loadingItems = true;
        await routesApi.changeLoadingLogist(
          this.id,
          this.editableRouteItem.id,
          this.editableRouteItem.loadingLogist,
        );
        this.$store.dispatch("route/getRouteItems", this.id);
        this.loadingItems = false;
        this.showInfo("Референс логиста изменен");
      } catch (error) {
        if (error.message) {
          this.loadingItems = false;
          this.showError(error.message);
        } else {
          this.loadingItems = false;
          throw error;
        }
      }
    },
    async getShippingsPackages() {
      this.shippingsPackages = await routesApi.getShippingsPackages(this.id);
    },
    async updatePackages() {
      await this.getPackages();
      await this.getShippingsPackages();
    },
  },
};
</script>

<style>
.v-select__slot input {
  font-size: 14px;
}
.route-prefix.v-text-field--outline .v-text-field__slot input {
  margin-top: 0 !important;
}
.route-prefix.v-text-field--outline .v-input__slot {
  padding-left: 5px !important;
  padding-right: 0 !important;
}
.route-prefix.v-text-field--outline .v-input__slot .v-input__append-inner {
  margin-top: 2px !important;
}
.editable-field {
  font-weight: bold;
}
</style>
